import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ClientProfileSidebarDTO,
  ISidebarState,
  SidebarMenuDTO,
} from "../../../types/sidebar";

/** 🧱 Estado inicial */
export const initialState: ISidebarState = {
  profile: null,
  categories: [],
  menus: {}, // 👈 los menús por módulo
  isModuleActive: false, // 👈 nuevo estado booleano
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    // =====================================================
    // 🌐 CONSULTAS BASE
    // =====================================================

    /**
     * 🔹 Cargar la estructura completa del sidebar
     * (perfil + categorías + módulos agrupados)
     */
    setSidebarData: (
      state,
      action: PayloadAction<ClientProfileSidebarDTO>
    ) => {
      state.profile = action.payload;
      state.categories = action.payload.categories;

      // Si viene del endpoint /full, cada módulo trae sus menús: los volcamos al
      // caché por módulo para que el sidebar marque el activo al recargar en frío.
      (action.payload.categories ?? []).forEach((category) => {
        (category.modules ?? []).forEach((module) => {
          if (Array.isArray(module.menus)) {
            state.menus[module.code] = module.menus;
          }
        });
      });
    },

    /**
     * 🔹 Cargar los menús asociados a un módulo específico
     * Se guardan de forma individual por `moduleCode`
     */
    setModuleMenus: (
      state,
      action: PayloadAction<{ moduleCode: string; menus: SidebarMenuDTO[] }>
    ) => {
      state.menus[action.payload.moduleCode] = action.payload.menus;
    },

    /**
     * 🔹 Activar o desactivar el estado del módulo
     * (por ejemplo, al navegar o limpiar)
     */
    setModuleActive: (state, action: PayloadAction<boolean>) => {
      state.isModuleActive = action.payload;
    },

    /** 🔄 Limpia los menús cargados de un módulo específico */
    clearMenus: (state, action: PayloadAction<string | undefined>) => {
      if (action.payload) {
        delete state.menus[action.payload];
      } else {
        state.menus = {};
      }
    },

    /** 🧹 Reinicia completamente el estado del sidebar */
    resetSidebarState: () => initialState,
  },
});

// =====================================================
// 📤 EXPORTAR ACTIONS
// =====================================================
export const {
  setSidebarData,
  setModuleMenus,
  clearMenus,
  resetSidebarState,
  setModuleActive, // 👈 nueva acción
} = sidebarSlice.actions;

// =====================================================
// 📤 EXPORTAR REDUCER
// =====================================================
export default sidebarSlice.reducer;
